Router.configure({
  layoutTemplate: 'layout',
  loadingTemplate: 'loading'
});

Router.route('/', {
  name: 'home',
  onBeforeAction: function () {
    if (Meteor.user()) {
      this.redirect('bands');
    } else {
      this.next();
    }
  }
});
    
Router.route('/bands', { name: 'bands',
  waitOn: function() {
		return [
      Meteor.subscribe('bands'),
      Meteor.subscribe('images')
    ];
	},
  onBeforeAction: function () {
    if (Meteor.user()) {
      this.next();
    } else {
      this.redirect('home');
    }
  }
})

Router.route('/band-admin', { name: 'bandAdmin',
  waitOn: function() {
		return [
      Meteor.subscribe('allBands'),
      Meteor.subscribe('images')
    ];
	}
})




    
Router.route('/band/:bandId', { name: 'band',
  waitOn: function() {
		return [ 
      Meteor.subscribe('singleBand'),
      Meteor.subscribe('images') 
    ];
	},
  onBeforeAction: function () {
    if (Meteor.user()) {
      this.next();
    } else {
      this.redirect('home');
    }
  }
})
